import Alpine from "alpinejs";
import { scrollTo } from "../../modules/scrollTo";

Alpine.magic("scrollToID", () => (id, ops) => {
  const el = document.getElementById(id.replace("#", ""));
  scrollTo(el, ops);
});
